import { ModalDialogContent, ModalDialogNav, ModalDialogCloseButton, ModalDialogBody, Box, H3, Typography, Button } from '@vp/swan'
import { produce } from 'immer'
import { Dispatch, SetStateAction } from 'react'
import { TextEditor } from './TextEditor'
import { RenderableTextField } from '../../Schemes/store/types'
import { UploadsModalOpenButton } from './Uploads/UploadsModalOpenButton'
import { usePersonalizationManager } from '../PersonalizationManager'

export interface PersonalizationModalContentProps {
  textFields: RenderableTextField[]
  setTextFields: Dispatch<SetStateAction<RenderableTextField[]>>
  handleSubmit: () => void
  handleSignIn: () => Promise<void>
  setShowUploadContent: (show: boolean) => void
}

export const PersonalizationModalContent = (props: PersonalizationModalContentProps) => {
  const { setShowUploadContent, setTextFields, textFields, handleSubmit } = props
  const { setMobileModalOpen, isInitialized, translations } = usePersonalizationManager()
  const { modalCopy } = translations

  const onTextChange = (index: number, value: string): void => {
    setTextFields((prevState) =>
      produce(prevState, (draft) => {
        draft[index].text = value
      }),
    )
  }

  return (
    <ModalDialogContent fullBleed>
      <ModalDialogNav>
        <ModalDialogCloseButton accessibleText={modalCopy.closeButtonText} onClick={(): void => setMobileModalOpen(false)} />
      </ModalDialogNav>
      <ModalDialogBody>
        {isInitialized && (
          <Box margin={5} marginTop={6}>
            <H3 fontSkin="title-section" mb={2}>
              {modalCopy.filterHeader}
            </H3>
            <Typography fontSkin="body-standard" mb={5}>
              {modalCopy.filterSubtext}
            </Typography>
            <Box mb="between-actions" pt={3}>
              <UploadsModalOpenButton
                onClick={(): void => {
                  setShowUploadContent(true)
                }}
              />
            </Box>
            <TextEditor setTextFields={setTextFields} textFields={textFields} onTextChange={onTextChange} />
            <Button mt="between-subsections" skin="primary" width="full-width" onClick={handleSubmit}>
              {modalCopy.submitButtonText}
            </Button>
          </Box>
        )}
      </ModalDialogBody>
    </ModalDialogContent>
  )
}
